import React from 'react'
import PropTypes from 'prop-types'
import { midas } from '@resurs/midas'
import { Checkbox, Column } from '@resurs/midas-react'
import { getText } from '../../../internal/TextLabels'
import { translateCountryCodeToLocalCountryName } from '../../../util/countries'
import TextInput from '../../../midasComponents/components/TextInput'
import {
  getValidationFormat,
  isEnabled,
  isRequired,
} from './StoreInfoSettingsHelper'

const StoreInfoSettingsForm = ({
  settings,
  taxNoteDefault,
  onChange,
  editMode,
  country,
}) => {
  const getInputField = tag => {
    if (tag === 'taxNote') {
      return (
        <Checkbox
          id={tag}
          checked={settings[tag] != null ? settings[tag] : taxNoteDefault}
          onChange={e => onChange(tag, e.target.checked)}
          disabled={!editMode}
        />
      )
    }
    if (tag === 'country') {
      return (
        <TextInput
          id={tag}
          disabled
          skipValidation
          value={translateCountryCodeToLocalCountryName(country)}
        />
      )
    }

    const additionalProps = {}

    const validationFormat = getValidationFormat(tag)
    if (validationFormat) {
      additionalProps['format'] = validationFormat
    } else {
      additionalProps['skipValidation'] = true
    }

    if (isRequired(tag)) {
      additionalProps['required'] = getText('default.form.required')
    }

    return (
      <TextInput
        id={tag}
        disabled={!editMode || !isEnabled(tag)}
        value={settings[tag] || ''}
        onChange={e => onChange(tag, e.target.value)}
        {...additionalProps}
      />
    )
  }

  const renderEditLine = tag => {
    return (
      <>
        <Column col4>
          <label className={midas.formLabel}>
            {getText(`storeSettings.storeinfo.${tag}`)}
            {isRequired(tag) && <span>&nbsp;*</span>}
          </label>
        </Column>
        <Column col8>
          <div style={{ width: '100%' }}>{getInputField(tag)}</div>
        </Column>
      </>
    )
  }

  return (
    <>
      {renderEditLine('legalname')}
      {renderEditLine('digitalname')}
      {renderEditLine('street')}
      {renderEditLine('zip')}
      {renderEditLine('city')}
      {renderEditLine('country')}
      {renderEditLine('phone')}
      {renderEditLine('fax')}
      {renderEditLine('email')}
      {renderEditLine('web')}
      {renderEditLine('vatreg')}
      {renderEditLine('orgnr')}
      {renderEditLine('taxNote')}
    </>
  )
}

StoreInfoSettingsForm.propTypes = {
  settings: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  editMode: PropTypes.bool.isRequired,
  country: PropTypes.string.isRequired,
  taxNoteDefault: PropTypes.bool,
}

StoreInfoSettingsForm.defaultProps = {
  settings: null,
  taxNoteDefault: true,
}

export default StoreInfoSettingsForm
